import {createSlice, type PayloadAction} from "@reduxjs/toolkit";

import type CalculationNoteFoundationLoadCase from "../../types/CalculationNoteFoundationLoadCase";

export interface ConstructionCalculationsNoteState {
  foundationResults:
    | Record<string, CalculationNoteFoundationLoadCase[]>
    | undefined;
}

const initialState: ConstructionCalculationsNoteState = {
  foundationResults: undefined,
};

export const constructionCalculationsNoteSlice = createSlice({
  name: "constructionCalculationsNote",
  initialState,
  reducers: {
    load: (
      state,
      {
        payload,
      }: PayloadAction<
        Record<string, CalculationNoteFoundationLoadCase[]> | undefined
      >,
    ) => {
      state.foundationResults = payload;
    },
  },
});

export const {load} = constructionCalculationsNoteSlice.actions;
export default constructionCalculationsNoteSlice.reducer;
